export default __webpack_public_path__ + "static/media/services.4074a445.jpg";